export const PRODUCT_TYPE = {
  PRODUCT_REDUCER_TYPE: "product-reducer-type",
  PRODUCT_SAGA_TYPE: "product-saga-type",
};
